import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { LineChart } from '../Charts/LineChart';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const CalculationsVsTime = () => {
  const [loadingGraph, setLoadingGraph] = useState(false);
  const [period, setPeriod] = useState(7);
  const [type, setType] = useState('all');

  const [lastXdayCalculationsData, setLastXdayCalculationsData] = useState([]);
  const [lastXdayCalculationsLabels, setLastXdayCalculationsLabels] = useState([]);
  const [lastXdayCalculationsDataCumulative, setLastXdayCalculationsDataCumulative] = useState([]);

  useEffect(() => {
    const getLastXPeriodCalculations = async () => {
      setLoadingGraph(true);

      try {
        const response = await axios({
          method: 'GET',
          url: `/api/v1/admin/getLastXPeriodCalculations/${period}/${type}`,
        });
        setLastXdayCalculationsData(response.data.data.dataSet);
        setLastXdayCalculationsLabels(response.data.data.labels);
        setLastXdayCalculationsDataCumulative(response.data.data.dataSetCumulative);
      } catch (err) {
        console.log('Error->', err.response.data.message);
      }
      setLoadingGraph(false);
    };
    getLastXPeriodCalculations();
  }, [period, type]);

  const data1 = {
    label: 'Calculations',
    period,
    labels: lastXdayCalculationsLabels,
    datasets: [
      {
        label: 'Calculations',
        data: lastXdayCalculationsData,
        borderColor: '#1976D2',
        backgroundColor: '#1976D2',
      },
    ],
  };

  const data2 = {
    label: 'Calculations (Cumulative)',
    period,
    labels: lastXdayCalculationsLabels,
    datasets: [
      {
        label: 'Calculations (Cumulative)',
        data: lastXdayCalculationsDataCumulative,
        borderColor: '#1976D2',
        backgroundColor: '#1976D2',
      },
    ],
  };

  return (
    <div className="SignupVsTime ">
      <div className="selectPeriod">
        <FormControl>
          <InputLabel id="active">Period</InputLabel>
          <Select
            size="small"
            labelId="active"
            value={period}
            label="Period"
            sx={{ width: '150px' }}
            onChange={(e) => {
              setPeriod(e.target.value);
            }}
          >
            <MenuItem value={7}>Last 7 days</MenuItem>
            <MenuItem value={15}>Last 15 days</MenuItem>
            <MenuItem value={30}>Last 30 days</MenuItem>
            <MenuItem value={90}>Last 3 months</MenuItem>
            <MenuItem value={180}>Last 6 months</MenuItem>
            <MenuItem value={365}>Last 12 months</MenuItem>
            <MenuItem value={730}>Last 2 years</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="selectCalculation">
        <FormControl>
          <InputLabel id="active">Calculation</InputLabel>
          <Select
            size="small"
            labelId="active"
            value={type}
            label="Calculation"
            sx={{ width: '150px' }}
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            <MenuItem value={'all'}>All</MenuItem>
            <MenuItem value={'consolidation'}>Consolidation</MenuItem>
            <MenuItem value={'pileRockSettle'}>Pile Rock Settle</MenuItem>
            <MenuItem value={'terzaghi'}>Terzaghi</MenuItem>
            <MenuItem value={'meyerhof'}>Meyerhof</MenuItem>
            <MenuItem value={'hansen'}>Hansen</MenuItem>
            <MenuItem value={'pileRockBc'}>Pilerockbc</MenuItem>
            <MenuItem value={'SptCorrection'}>Spt Correction</MenuItem>
            <MenuItem value={'liquefaction'}>Liquefaction</MenuItem>
            <MenuItem value={'layeredSoil'}>Layered Soil</MenuItem>
            <MenuItem value={'slopeStability'}>Slope Stability</MenuItem>
            <MenuItem value={'mohrCircle'}>Mohr Circle</MenuItem>
            <MenuItem value={'weightVolumeRelationships'}>Weight Volume</MenuItem>
            <MenuItem value={'stroud'}>Stroud</MenuItem>
            <MenuItem value={'clayEffectiveFrictionAngle'}>Clay Friction Angle</MenuItem>
            <MenuItem value={'cvLLUsNavy'}>Cv Vs LL</MenuItem>
            <MenuItem value={'stressIncrease'}>Stress Increase</MenuItem>
            <MenuItem value={'priebe'}>Priebe</MenuItem>
            <MenuItem value={'uscsClassifier'}>USCS Classifier</MenuItem>
            <MenuItem value={'vs30SiteClassEc8'}>Vs30 Site Class</MenuItem>
          </Select>
        </FormControl>
      </div>
      {loadingGraph ? (
        <CircularProgress />
      ) : (
        <>
          <LineChart data={data1} />
          <LineChart data={data2} />
        </>
      )}
    </div>
  );
};

export default CalculationsVsTime;
